export function RightRunIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.96729 2.50098C6.47015 2.49967 6.96443 2.63232 7.3999 2.88379L15.4497 7.5V7.56641C15.8821 7.81666 16.2411 8.17663 16.4907 8.60938C16.7403 9.04227 16.8725 9.53349 16.8726 10.0332C16.8726 10.533 16.7404 11.0241 16.4907 11.457C16.2411 11.8899 15.8822 12.2497 15.4497 12.5L7.3999 17.1172C6.96675 17.3674 6.47531 17.4991 5.9751 17.5C5.21923 17.5 4.49395 17.1995 3.95947 16.665C3.4252 16.1307 3.1246 15.406 3.12451 14.6504V5.38379C3.11888 4.88084 3.24681 4.38496 3.49463 3.94727C3.74239 3.5097 4.10162 3.14551 4.53564 2.8916C4.96985 2.63768 5.46428 2.50236 5.96729 2.50098ZM5.9751 4.16699C5.76785 4.17023 5.56447 4.22449 5.3833 4.3252C5.20345 4.42903 5.05356 4.57797 4.94971 4.75781C4.84592 4.93761 4.79154 5.14201 4.7915 5.34961V14.6504C4.79153 14.858 4.8459 15.0624 4.94971 15.2422C5.05356 15.422 5.20344 15.571 5.3833 15.6748C5.56373 15.7771 5.76771 15.8311 5.9751 15.8311C6.18241 15.831 6.38653 15.777 6.56689 15.6748L14.6167 10.9922V11.0254C14.7967 10.9216 14.9464 10.7717 15.0503 10.5918C15.1541 10.4119 15.2085 10.2077 15.2085 10C15.2085 9.79229 15.1542 9.58808 15.0503 9.4082C14.9464 9.22827 14.7967 9.07844 14.6167 8.97461L6.56689 4.3252C6.38541 4.22547 6.18213 4.17128 5.9751 4.16699Z"
        fill="currentColor"
      />
    </svg>
  );
}
